import { useEffect } from "react";
import { useLocation } from "react-router-dom"; // Remove if not using react-router

export default function ScrollToTop() {
  // 1. Listen to route changes (Optional: remove if tracking something else)
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }, [pathname]);

  return null; // 3. Render nothing visually
}
